import { orderBy } from 'lodash'
import moment from 'moment-timezone'

export const getDefaultTimezone = (confTimezone) =>
  confTimezone ? confTimezone : 'America/Los_Angeles'

export const convertTimestampToLocalString = (timestamp, timezone, is24hrFormat) => {
  const format = is24hrFormat ? 'M/D/YYYY HH:mm' : 'M/D/YYYY h:mm A'
  return moment(timestamp).tz(getDefaultTimezone(timezone)).format(format)
}

export const sortDataArrayByCreatedAt = (data = [], order = 'asc') => {
  return orderBy(
    data,
    [(item) => item?.startDate || '', (item) => item.createdAt || ''],
    [order, order]
  )
}
